<template>

    <form ref="certificacoespoliticapreco-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-5">
                <label for="politicaComercial">Nome</label>
                <input type="text" class="form-control" id="politicaComercial" placeholder="Nome da Politica Comercial" maxlength="50" v-model="model.nome" />
            </div>
            <div class="form-group col-md-1">
                <label>Ativa?</label>
                <div class="form-group">
                    <label class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" name="politicaComercialAtivo" value="undefined" class="custom-control-input" v-model="model.ativo">
                        <span class="custom-control-indicator"></span>
                    </label>

                </div>

            </div>
            <div class="table-responsive standard-table header-cinza">
                <p class="font-weight-bold ml-3">Informe abaixo os valores para cada tipo de exame e tipo de candidato:</p>
                <table>
                    <thead>
                        <tr>
                            <th>ID<i></i></th>
                            <th>EXAME</th>
                            <th>VALOR PARA ALUNOS</th>
                            <th>VALOR PARA COLABORADORES</th>
                            <th>VALOR PARA EXTERNOS</th>
                            <th>VALOR PARA TROCA DE EXAMES</th>
                            <th>CONDIÇÃO APLICADA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in result.items" class="animated fadeIn">
                            <td>{{ item.interesseId}}</td>
                            <td>{{ item.nome}}</td>
                            <td>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input type="text" v-money="money" class="form-control" name="valorAlunos" id="valorAlunos" v-model="item.valorAlunos">

                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input type="text" v-money="money" class="form-control" name="valorColaboradores" id="valorColaboradores" v-model="item.valorColaboradores" />
                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input type="text" v-money="money" class="form-control" name="valorExternos" id="valorExternos" v-model="item.valorExternos" />
                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input type="text" v-money="money" class="form-control" name="valorTrocaExames" id="valorTrocaExames" v-model="item.valorTrocaExames" />
                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <label>Ativa?</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" name="anularAproveitamento" value="undefined" class="custom-control-input" v-model="item.anularAproveitamento">
                                            <span class="custom-control-indicator"></span>
                                        </label>

                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-11">
                <div class="pull-left" style="color:red; font-size:small" id="errors"></div>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="openCreate(model)">
            <span>Salvar</span>
        </button>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" title="Confirmação">
            <p>Foram encontrados campos em branco. Deseja preenche-los com o valor "0,00"?</p>
            <div slot="modal-footer">
                <button type="button" class="btn btn-default" @click="cancelar()">
                    <span>Cancelar</span>
                </button>
                <button class="btn btn-sm btn-danger" @click="executeCreate(model)">
                    Confirmar
                </button>
            </div>
        </b-modal>
    </form>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "certificacoespoliticapreco-form-create",
        mixins: [base],
        data: () => ({
            certificacoespoliticaprecoInteresse: {
                id: 0,
                certificacoesPoliticaPrecoId: 0,
                interesseId: 0,
                valorAlunos: null,
                valorColaboradores: null,
                valorExternos: null
            },

            politicasPrecoInteresseLista: [],
            novasPoliticasPrecoInteresseLista: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false,
            },
            model: {
                collectionCertificacoesPoliticaPrecoInteresse: [],
            },
            dialogCreate: false,

            form: "certificacoespoliticapreco-form-create",
            filter: {
                pageSize: 50,
                pageIndex: 1,
                isPagination: true,
            },
            result: {
                total: 0,
                index: null,
                items: [],
            },
            resources: {
                filter: 'interesse',
                create: 'certificacoespoliticapreco',
                createPoliticaPrecoInteresse: 'certificacoesPoliticaPrecoInteresse',
            },

        }),

        methods: {
            cancelar: function () {
                this.dialogCreate = false;
            },
            openCreate: function (model) {

                this.model.collectionCertificacoesPoliticaPrecoInteresse = this.result.items;
                for (var i = 0; i < this.model.collectionCertificacoesPoliticaPrecoInteresse.length; i++) {
                    if (this.model.collectionCertificacoesPoliticaPrecoInteresse[i].valorAlunos == "0,00" || this.model.collectionCertificacoesPoliticaPrecoInteresse[i].valorColaboradores == "0,00" || this.model.collectionCertificacoesPoliticaPrecoInteresse[i].valorExternos == "0,00") {
                        this.dialogCreate = true;
                        break;
                    }
                }
                if (this.dialogCreate == false)
                    this.executeCreate(model);
            },
            createCertificacaoInteresse: function (listaModel) {
                new Api(this.resources.createPoliticaPrecoInteresse).post(listaModel).then(lista => {
                    this.$emit('on-saved', lista)
                })
            },
            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeCreate: function (model) {
                if (document.getElementById('politicaComercial').value == "")
                    document.getElementById('errors').innerHTML = "";
                this.model.collectionCertificacoesPoliticaPrecoInteresse = this.result.items;
                new Api('certificacoespoliticapreco/gravar').post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            executeLoad: function () {
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;

                },
                );
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },


            onBack: function () {
                this.$emit('on-back')
            },
        },
        mounted() {
            this.executeFilter();
        }
    };
</script>

